import { createAsyncThunk } from '@reduxjs/toolkit';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';

export const GetCurrentEventsOfAllOpportunities = createAsyncThunk(
    'marketplace/getCurrentEventsOfAllOpportunities',
    async (filterParams: TableFilter, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const queryString = objectToQueryString(filterParams);

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceOpportunities/CurrentEventsOfAllOpportunities?${queryString}`
            );
            if (response.status !== 200) {
                throw new Error('Failed to fetch events');
            }

            return {
                events: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching events.',
                'error'
            );
            throw error;
        }
    }
);
